import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

interface DayTrip {
  id: string;
  name: string;
  distance: string;
  duration: string;
  difficulty: "Kolay" | "Orta" | "Zorlu";
  category: string;
  tags: string[];
  description: string;
  highlights: string[];
  bestSeason: string[];
  tips: string[];
  image: string;
  route: string;
  activities: string[];
  cost: string;
}

const dayTrips: DayTrip[] = [
  {
    id: "sapanca",
    name: "Sapanca Gölü & Orman Yürüyüşü",
    distance: "~130 km",
    duration: "1 gün",
    difficulty: "Kolay",
    category: "Doğa",
    tags: ["Göl", "Orman", "Piknik", "Bungalov"],
    description: "İstanbul'un en yakın nefes alma noktalarından Sapanca, gölün berrak suları ve çam ormanlarıyla huzur dolu bir günübirlik kaçamak sunuyor. Sabah erken çıkıp öğle saatlerinde göl kenarında piknik yapabilir, öğleden sonra orman yürüyüşüyle günü tamamlayabilirsiniz.",
    highlights: ["Sapanca Gölü kıyısı yürüyüşü", "Kırkpınar Ormanı doğa yürüyüşü", "Göl kenarı kafeler ve restoranlar", "Bungalov konaklama seçenekleri", "Taze balık restoranları"],
    bestSeason: ["İlkbahar", "Yaz", "Sonbahar"],
    tips: ["Hafta sonu erken çıkın, trafik yoğun olabilir", "Piknik malzemelerinizi İstanbul'dan hazırlayın", "Göl kenarı yürüyüş parkuru 8 km, rahat ayakkabı şart", "Dönüşte Adapazarı'nda ıslama köfte deneyin"],
    image: "https://readdy.ai/api/search-image?query=Sapanca%20Lake%20Turkey%20serene%20blue%20water%20forest%20reflection%20morning%20mist%20green%20trees%20peaceful%20nature%20landscape&width=900&height=560&seq=dt-sapanca&orientation=landscape",
    route: "İstanbul → TEM Otoyolu → Sapanca Çıkışı → Göl Kıyısı",
    activities: ["Yürüyüş", "Piknik", "Balık tutma", "Bisiklet", "Tekne turu"],
    cost: "₺ Ekonomik",
  },
  {
    id: "kartepe",
    name: "Kartepe Dağı & Kayak Merkezi",
    distance: "~120 km",
    duration: "1 gün",
    difficulty: "Orta",
    category: "Dağ",
    tags: ["Dağ", "Kayak", "Manzara", "Bungalov"],
    description: "Kocaeli'nin zirvesinde yer alan Kartepe, kışın kayak pistleri, yazın ise İzmit Körfezi'nin panoramik manzarasıyla büyülüyor. Teleferikle zirveye çıkıp körfezi seyredebilir, kış aylarında kayak yapabilirsiniz.",
    highlights: ["Kartepe Kayak Merkezi pistleri", "Teleferik ile zirve manzarası", "İzmit Körfezi panoraması", "Dağ restoranları ve çay bahçeleri", "Bungalov ve dağ evleri"],
    bestSeason: ["Kış", "İlkbahar", "Yaz"],
    tips: ["Kış aylarında kayak ekipmanı kiralayabilirsiniz", "Teleferik için erken gidin, kuyruk uzuyor", "Zirvedeki hava İstanbul'dan çok daha soğuk, mont alın", "Dönüşte İzmit'te pişmaniye almayı unutmayın"],
    image: "https://readdy.ai/api/search-image?query=Kartepe%20mountain%20Turkey%20ski%20resort%20winter%20snow%20panoramic%20view%20Izmit%20Bay%20cable%20car%20scenic%20landscape&width=900&height=560&seq=dt-kartepe&orientation=landscape",
    route: "İstanbul → TEM Otoyolu → Gebze → Kartepe",
    activities: ["Kayak", "Teleferik", "Yürüyüş", "Fotoğrafçılık", "Dağ bisikleti"],
    cost: "₺₺ Orta",
  },
  {
    id: "agva",
    name: "Ağva Nehir Kaçamağı",
    distance: "~100 km",
    duration: "1 gün",
    difficulty: "Kolay",
    category: "Doğa",
    tags: ["Nehir", "Kamp", "Kano", "Doğa"],
    description: "İstanbul'a en yakın doğa kaçamağı olan Ağva, Göksu ve Yeşilçay nehirlerinin Karadeniz'e döküldüğü noktada büyüleyici bir atmosfer sunuyor. Kano, SUP ve nehir yüzme aktiviteleriyle dolu bir gün geçirebilirsiniz.",
    highlights: ["Göksu ve Yeşilçay nehirlerinde kano", "Karadeniz sahilinde yürüyüş", "Nehir kenarı balık restoranları", "Kamp ve karavan alanları", "Orman içi yürüyüş parkurları"],
    bestSeason: ["İlkbahar", "Yaz", "Sonbahar"],
    tips: ["Kano kiralama için önceden rezervasyon yapın", "Nehir suyu soğuk olabilir, yüzme için hazırlıklı olun", "Hafta sonu çok kalabalık, hafta içi tercih edin", "Taze balık için nehir kenarı lokantalara gidin"],
    image: "https://readdy.ai/api/search-image?query=Agva%20river%20Turkey%20canoe%20kayak%20green%20forest%20nature%20peaceful%20water%20reflection%20summer%20adventure&width=900&height=560&seq=dt-agva&orientation=landscape",
    route: "İstanbul → D-100 → Şile Yolu → Ağva",
    activities: ["Kano", "SUP", "Yüzme", "Balık tutma", "Kamp"],
    cost: "₺ Ekonomik",
  },
  {
    id: "abant",
    name: "Abant Gölü Tabiat Parkı",
    distance: "~200 km",
    duration: "1 gün",
    difficulty: "Kolay",
    category: "Doğa",
    tags: ["Göl", "Tabiat Parkı", "Yürüyüş", "Bungalov"],
    description: "Bolu'nun incisi Abant Gölü, dört mevsim farklı güzellikler sunan bir tabiat parkı. Gölün etrafındaki 7 km'lik yürüyüş parkuru, at binme imkânı ve göl kenarı restoranlarıyla tam bir günübirlik kaçamak.",
    highlights: ["Abant Gölü çevre yürüyüş parkuru (7 km)", "At binme aktivitesi", "Göl kenarı restoranlar", "Bolu ormanlarında doğa yürüyüşü", "Fotoğraf çekimi için eşsiz manzaralar"],
    bestSeason: ["İlkbahar", "Yaz", "Sonbahar", "Kış"],
    tips: ["Giriş ücreti var, nakit bulundurun", "Yürüyüş parkuru kolay ama uzun, su götürün", "Sonbahar renkleri için Ekim-Kasım ideal", "Kış aylarında göl donabilir, muhteşem manzara"],
    image: "https://readdy.ai/api/search-image?query=Abant%20Lake%20Turkey%20Bolu%20nature%20park%20misty%20morning%20forest%20reflection%20autumn%20colors%20serene%20peaceful&width=900&height=560&seq=dt-abant&orientation=landscape",
    route: "İstanbul → TEM Otoyolu → Bolu → Abant",
    activities: ["Yürüyüş", "At binme", "Fotoğrafçılık", "Piknik", "Balık tutma"],
    cost: "₺ Ekonomik",
  },
  {
    id: "sile",
    name: "Şile Sahil & Deniz Feneri",
    distance: "~70 km",
    duration: "Yarım gün / 1 gün",
    difficulty: "Kolay",
    category: "Sahil",
    tags: ["Deniz", "Sahil", "Tarihi", "Plaj"],
    description: "İstanbul'a en yakın Karadeniz sahili olan Şile, tarihi deniz feneri, kumlu plajları ve taze balık restoranlarıyla hafta sonu kaçamağı için mükemmel. Şile bezi alışverişini de unutmayın.",
    highlights: ["Şile Deniz Feneri ve tarihi kale", "Uzun kumlu Şile plajı", "Taze Karadeniz balığı restoranları", "Şile bezi alışverişi", "Kıyı boyunca yürüyüş"],
    bestSeason: ["İlkbahar", "Yaz", "Sonbahar"],
    tips: ["Yaz aylarında plaj çok kalabalık, sabah erken gidin", "Şile bezi için çarşıyı gezip fiyat karşılaştırın", "Deniz feneri çevresinde güzel fotoğraf noktaları var", "Dönüşte Ağva'ya da uğrayabilirsiniz"],
    image: "https://readdy.ai/api/search-image?query=Sile%20lighthouse%20Turkey%20Black%20Sea%20coast%20rocky%20cliffs%20blue%20water%20historic%20tower%20scenic%20coastal%20landscape&width=900&height=560&seq=dt-sile&orientation=landscape",
    route: "İstanbul → Ümraniye → Şile Yolu → Şile",
    activities: ["Yüzme", "Yürüyüş", "Alışveriş", "Balık yeme", "Fotoğrafçılık"],
    cost: "₺ Ekonomik",
  },
  {
    id: "polonezköy",
    name: "Polonezköy Doğa Parkı",
    distance: "~35 km",
    duration: "Yarım gün",
    difficulty: "Kolay",
    category: "Doğa",
    tags: ["Orman", "Tarihi", "Piknik", "Kısa"],
    description: "İstanbul'a sadece 35 km uzaklıkta, Polonyalı göçmenlerin kurduğu tarihi köy Polonezköy, yoğun ormanları ve doğa parkıyla şehrin stresini atmak için ideal. Yarım günde gidip dönebilirsiniz.",
    highlights: ["Polonezköy Doğa Parkı orman yürüyüşü", "Tarihi Polonyalı köy mimarisi", "Orman içi piknik alanları", "Çiftlik hayvanları ve doğal yaşam", "Köy restoranlarında ev yemekleri"],
    bestSeason: ["İlkbahar", "Yaz", "Sonbahar"],
    tips: ["Hafta içi çok sakin, hafta sonu kalabalık", "Yürüyüş için spor ayakkabı yeterli", "Köy restoranlarında rezervasyon yapın", "Çocuklar için harika bir gün"],
    image: "https://readdy.ai/api/search-image?query=Polonezkoy%20nature%20park%20Istanbul%20Turkey%20dense%20forest%20green%20trees%20wooden%20houses%20village%20peaceful%20autumn&width=900&height=560&seq=dt-polonez&orientation=landscape",
    route: "İstanbul → Beykoz → Polonezköy",
    activities: ["Yürüyüş", "Piknik", "Fotoğrafçılık", "Çiftlik ziyareti"],
    cost: "₺ Ekonomik",
  },
  {
    id: "yalova",
    name: "Yalova Termal & Armutlu",
    distance: "~80 km (feribot dahil)",
    duration: "1 gün",
    difficulty: "Kolay",
    category: "Termal",
    tags: ["Termal", "Feribot", "Sahil", "Spa"],
    description: "İstanbul'dan feribotle sadece 1 saatte ulaşabileceğiniz Yalova, termal kaplıcaları ve Armutlu'nun sakin sahiliyle farklı bir günübirlik deneyim sunuyor. Feribot yolculuğu başlı başına keyifli.",
    highlights: ["Yalova Termal Kaplıcaları", "Armutlu sahil yürüyüşü", "Feribot ile Marmara denizi manzarası", "Termal otellerde günübirlik spa", "Yalova çiçek bahçeleri"],
    bestSeason: ["İlkbahar", "Yaz", "Sonbahar", "Kış"],
    tips: ["Feribot saatlerini önceden kontrol edin", "Termal için mayo ve havlu götürün", "Kış aylarında termal daha keyifli", "Armutlu'da taze deniz ürünleri deneyin"],
    image: "https://readdy.ai/api/search-image?query=Yalova%20thermal%20springs%20Turkey%20spa%20wellness%20hot%20springs%20nature%20green%20garden%20relaxation%20scenic&width=900&height=560&seq=dt-yalova&orientation=landscape",
    route: "İstanbul (Yenikapı) → Feribot → Yalova → Termal / Armutlu",
    activities: ["Termal banyo", "Spa", "Yüzme", "Yürüyüş", "Feribot turu"],
    cost: "₺₺ Orta",
  },
  {
    id: "bursa-uludag",
    name: "Bursa & Uludağ Günübirlik",
    distance: "~150 km (feribot dahil)",
    duration: "1 gün",
    difficulty: "Orta",
    category: "Dağ",
    tags: ["Dağ", "Tarihi", "Kayak", "Kültür"],
    description: "Osmanlı'nın ilk başkenti Bursa, tarihi çarşıları, İskender kebabı ve Uludağ'ın muhteşem manzarasıyla dolu bir günübirlik program sunuyor. Feribotle gidip hem tarihi hem doğayı keşfedebilirsiniz.",
    highlights: ["Uludağ Milli Parkı teleferik turu", "Bursa Kapalı Çarşı ve Ulu Cami", "Tarihi İskender kebabı", "Yeşil Türbe ve Yeşil Cami", "Koza Han ipek alışverişi"],
    bestSeason: ["İlkbahar", "Yaz", "Sonbahar", "Kış"],
    tips: ["Feribotle Mudanya'ya gelin, daha hızlı", "Uludağ için teleferik biletini önceden alın", "İskender için Kebapçı İskender'e gidin", "Kış aylarında kayak için ekstra zaman planlayın"],
    image: "https://readdy.ai/api/search-image?query=Bursa%20Uludag%20mountain%20Turkey%20ski%20resort%20winter%20snow%20panoramic%20view%20historic%20city%20Ottoman%20architecture&width=900&height=560&seq=dt-bursa&orientation=landscape",
    route: "İstanbul (Yenikapı) → Feribot → Mudanya → Bursa → Uludağ",
    activities: ["Kayak", "Teleferik", "Tarihi tur", "Alışveriş", "Gastronomi"],
    cost: "₺₺ Orta",
  },
];

const categories = ["Tümü", "Doğa", "Dağ", "Sahil", "Termal"];
const difficulties = ["Tümü", "Kolay", "Orta", "Zorlu"];
const seasons = ["Tümü", "İlkbahar", "Yaz", "Sonbahar", "Kış"];

const difficultyColors: Record<string, string> = {
  Kolay: "bg-emerald-100 text-emerald-700",
  Orta: "bg-amber-100 text-amber-700",
  Zorlu: "bg-rose-100 text-rose-700",
};

const categoryIcons: Record<string, string> = {
  Doğa: "ri-leaf-line",
  Dağ: "ri-landscape-line",
  Sahil: "ri-sailboat-line",
  Termal: "ri-drop-line",
  Tümü: "ri-map-2-line",
};

const DayTripsGuide = () => {
  const [selectedCategory, setSelectedCategory] = useState("Tümü");
  const [selectedDifficulty, setSelectedDifficulty] = useState("Tümü");
  const [selectedSeason, setSelectedSeason] = useState("Tümü");
  const [selectedTrip, setSelectedTrip] = useState<DayTrip | null>(null);
  const [search, setSearch] = useState("");

  const filtered = dayTrips.filter((t) => {
    const matchCat = selectedCategory === "Tümü" || t.category === selectedCategory;
    const matchDiff = selectedDifficulty === "Tümü" || t.difficulty === selectedDifficulty;
    const matchSeason = selectedSeason === "Tümü" || t.bestSeason.includes(selectedSeason);
    const matchSearch = !search
      || t.name.toLowerCase().includes(search.toLowerCase())
      || t.description.toLowerCase().includes(search.toLowerCase())
      || t.tags.some((tag) => tag.toLowerCase().includes(search.toLowerCase()));
    return matchCat && matchDiff && matchSeason && matchSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 overflow-hidden" style={{ minHeight: "480px" }}>
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Istanbul%20Bosphorus%20bridge%20aerial%20view%20city%20skyline%20golden%20hour%20sunset%20Turkey%20beautiful%20panoramic%20landscape&width=1400&height=500&seq=dt-hero-main&orientation=landscape"
            alt="Günübirlik Kaçamaklar"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        </div>
        <div className="relative max-w-5xl mx-auto px-4 md:px-8 py-20 text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest">
              İstanbul Çıkışlı
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Günübirlik Kaçamaklar
          </h1>
          <p className="text-stone-200 text-base max-w-2xl mx-auto mb-8 leading-relaxed">
            İstanbul'dan 1-3 saatlik mesafede, aynı gün gidip dönebileceğiniz en güzel doğa, dağ ve sahil rotaları.
          </p>
          {/* Stats */}
          <div className="flex items-center justify-center gap-8 flex-wrap">
            {[
              { icon: "ri-map-pin-line", value: "8", label: "Rota" },
              { icon: "ri-time-line", value: "1-3 saat", label: "Mesafe" },
              { icon: "ri-car-line", value: "Araç / Feribot", label: "Ulaşım" },
              { icon: "ri-calendar-line", value: "4 Mevsim", label: "Seçenek" },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <div className="flex items-center justify-center gap-1.5 text-amber-400 mb-1">
                  <i className={`${s.icon} text-lg`}></i>
                  <span className="text-white font-bold text-lg">{s.value}</span>
                </div>
                <p className="text-stone-300 text-xs">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">

        {/* Search + Filters */}
        <div className="bg-stone-50 rounded-2xl p-5 mb-8 border border-stone-100">
          <div className="flex flex-col md:flex-row gap-4">
            {/* Search */}
            <div className="relative flex-1">
              <div className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-stone-400 text-sm"></i>
              </div>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Rota veya aktivite ara..."
                className="w-full bg-white border border-stone-200 rounded-xl pl-10 pr-4 py-2.5 text-sm outline-none focus:border-amber-400 transition-colors"
              />
            </div>
            {/* Season filter */}
            <select
              value={selectedSeason}
              onChange={(e) => setSelectedSeason(e.target.value)}
              className="border border-stone-200 rounded-xl px-4 py-2.5 text-sm text-stone-700 outline-none focus:border-amber-400 bg-white cursor-pointer"
            >
              {seasons.map((s) => <option key={s} value={s}>{s === "Tümü" ? "Tüm Mevsimler" : s}</option>)}
            </select>
            {/* Difficulty filter */}
            <select
              value={selectedDifficulty}
              onChange={(e) => setSelectedDifficulty(e.target.value)}
              className="border border-stone-200 rounded-xl px-4 py-2.5 text-sm text-stone-700 outline-none focus:border-amber-400 bg-white cursor-pointer"
            >
              {difficulties.map((d) => <option key={d} value={d}>{d === "Tümü" ? "Tüm Zorluklar" : d}</option>)}
            </select>
          </div>

          {/* Category tabs */}
          <div className="flex gap-2 flex-wrap mt-4">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  selectedCategory === cat
                    ? "bg-stone-900 text-white"
                    : "bg-white text-stone-600 border border-stone-200 hover:border-stone-400"
                }`}
              >
                <i className={`${categoryIcons[cat] || "ri-map-line"} text-xs`}></i>
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Results count */}
        <div className="flex items-center justify-between mb-6">
          <p className="text-sm text-stone-500">
            <strong className="text-stone-900">{filtered.length}</strong> rota listeleniyor
          </p>
          <Link
            to="/accommodations"
            className="flex items-center gap-2 px-4 py-2 bg-amber-500 text-white text-sm font-semibold rounded-xl hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-hotel-line"></i>
            Konaklama Bul
          </Link>
        </div>

        {/* Trip Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {filtered.map((trip) => (
            <div
              key={trip.id}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden group cursor-pointer hover:border-amber-200 transition-all duration-200"
              onClick={() => setSelectedTrip(trip)}
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={trip.image}
                  alt={trip.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>

                {/* Top badges */}
                <div className="absolute top-3 left-3 flex items-center gap-2 flex-wrap">
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${difficultyColors[trip.difficulty]}`}>
                    {trip.difficulty}
                  </span>
                  <span className="bg-black/50 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full font-medium">
                    {trip.category}
                  </span>
                </div>

                {/* Distance badge */}
                <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full font-medium flex items-center gap-1">
                  <i className="ri-car-line text-amber-400"></i>
                  {trip.distance}
                </div>

                {/* Bottom info */}
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-bold text-base leading-tight mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {trip.name}
                  </h3>
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-1">
                      <i className="ri-time-line text-amber-400 text-xs"></i>
                      <span className="text-white/80 text-xs">{trip.duration}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <i className="ri-money-cny-circle-line text-amber-400 text-xs"></i>
                      <span className="text-white/80 text-xs">{trip.cost}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <p className="text-stone-500 text-xs leading-relaxed mb-3 line-clamp-2">{trip.description}</p>

                {/* Tags */}
                <div className="flex flex-wrap gap-1 mb-3">
                  {trip.tags.map((tag) => (
                    <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-stone-100 text-stone-500">{tag}</span>
                  ))}
                </div>

                {/* Activities */}
                <div className="flex flex-wrap gap-1 mb-4">
                  {trip.activities.slice(0, 3).map((act) => (
                    <span key={act} className="text-xs px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 font-medium">{act}</span>
                  ))}
                  {trip.activities.length > 3 && (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-stone-100 text-stone-400">+{trip.activities.length - 3}</span>
                  )}
                </div>

                {/* Season badges */}
                <div className="flex items-center gap-1 pt-3 border-t border-stone-50">
                  <i className="ri-calendar-line text-stone-400 text-xs mr-1"></i>
                  {trip.bestSeason.map((s) => (
                    <span key={s} className="text-xs text-stone-400">{s}</span>
                  )).reduce((prev, curr, i) => (
                    <>{prev}{i > 0 && <span className="text-stone-200 mx-0.5">·</span>}{curr}</>
                  ))}
                </div>
              </div>

              {/* CTA */}
              <div className="px-4 pb-4">
                <button
                  onClick={(e) => { e.stopPropagation(); setSelectedTrip(trip); }}
                  className="w-full flex items-center justify-center gap-2 py-2.5 bg-stone-900 hover:bg-stone-700 text-white text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-map-pin-line"></i>
                  Rota Detayları
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Tips Section */}
        <div className="bg-stone-50 rounded-2xl p-8 mb-12 border border-stone-100">
          <h2 className="text-xl font-bold text-stone-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Günübirlik Kaçamak İpuçları
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { icon: "ri-time-line", title: "Erken Çıkın", desc: "Hafta sonu trafiğini atlatmak için sabah 7-8'de yola çıkın. Hem trafik az hem de varış noktasında daha fazla zaman geçirirsiniz." },
              { icon: "ri-map-2-line", title: "Rota Planlayın", desc: "Google Maps'te rotanızı önceden kaydedin. Bazı noktalarda sinyal zayıf olabilir, offline harita indirin." },
              { icon: "ri-first-aid-kit-line", title: "Hazırlıklı Olun", desc: "Su, atıştırmalık, güneş kremi ve yedek kıyafet mutlaka yanınızda olsun. Hava değişken olabilir." },
              { icon: "ri-hotel-line", title: "Geceleyebilirsiniz", desc: "Günübirlik planladığınız rotaları bungalov veya kamp alanlarıyla gecelik tatile dönüştürebilirsiniz." },
            ].map((tip) => (
              <div key={tip.title} className="bg-white rounded-xl p-5 border border-stone-100">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl mb-3">
                  <i className={`${tip.icon} text-amber-600 text-lg`}></i>
                </div>
                <h4 className="font-bold text-stone-900 text-sm mb-2">{tip.title}</h4>
                <p className="text-stone-500 text-xs leading-relaxed">{tip.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-2xl overflow-hidden border border-amber-200">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Turkey%20nature%20bungalow%20caravan%20camping%20forest%20lake%20peaceful%20scenic%20landscape%20warm%20golden%20light&width=1200&height=300&seq=dt-cta-banner&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-stone-900/90 to-stone-900/50"></div>
          </div>
          <div className="relative px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                Gecelemek İster misiniz?
              </h3>
              <p className="text-stone-300 text-sm max-w-lg">
                Günübirlik rotalarınızı bungalov, karavan veya kamp alanlarıyla gecelik tatile dönüştürün. Sapanca, Kartepe ve Ağva'da harika seçenekler sizi bekliyor.
              </p>
            </div>
            <div className="flex gap-3 flex-shrink-0">
              <Link
                to="/accommodations"
                className="flex items-center gap-2 px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white text-sm font-bold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-hotel-line"></i>
                Konaklama Bul
              </Link>
              <Link
                to="/guides/karadeniz-yayla-rehberi"
                className="flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 border border-white/30 text-white text-sm font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-landscape-line"></i>
                Yayla Rehberi
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      {selectedTrip && (
        <div
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
          onClick={() => setSelectedTrip(null)}
        >
          <div
            className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Image */}
            <div className="relative h-64 overflow-hidden rounded-t-2xl">
              <img
                src={selectedTrip.image}
                alt={selectedTrip.name}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <button
                onClick={() => setSelectedTrip(null)}
                className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-black/40 hover:bg-black/60 rounded-full cursor-pointer transition-colors"
              >
                <i className="ri-close-line text-white text-lg"></i>
              </button>
              <div className="absolute bottom-4 left-5 right-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${difficultyColors[selectedTrip.difficulty]}`}>
                    {selectedTrip.difficulty}
                  </span>
                  <span className="bg-black/50 text-white text-xs px-2.5 py-1 rounded-full">{selectedTrip.category}</span>
                  <span className="bg-amber-500/80 text-white text-xs px-2.5 py-1 rounded-full font-semibold">{selectedTrip.cost}</span>
                </div>
                <h2 className="text-white text-xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {selectedTrip.name}
                </h2>
              </div>
            </div>

            {/* Modal Content */}
            <div className="p-6 space-y-5">
              {/* Quick Info */}
              <div className="grid grid-cols-3 gap-3">
                {[
                  { icon: "ri-car-line", label: "Mesafe", value: selectedTrip.distance },
                  { icon: "ri-time-line", label: "Süre", value: selectedTrip.duration },
                  { icon: "ri-calendar-line", label: "En İyi Sezon", value: selectedTrip.bestSeason.join(", ") },
                ].map((info) => (
                  <div key={info.label} className="bg-stone-50 rounded-xl p-3 text-center">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto mb-1.5 bg-amber-100 rounded-lg">
                      <i className={`${info.icon} text-amber-600 text-sm`}></i>
                    </div>
                    <p className="text-xs text-stone-400 mb-0.5">{info.label}</p>
                    <p className="text-xs font-bold text-stone-800">{info.value}</p>
                  </div>
                ))}
              </div>

              {/* Route */}
              <div className="bg-amber-50 rounded-xl p-4 border border-amber-100">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-route-line text-amber-600"></i>
                  <span className="text-xs font-bold text-amber-800 uppercase tracking-wide">Rota</span>
                </div>
                <p className="text-sm text-amber-900 font-medium">{selectedTrip.route}</p>
              </div>

              {/* Description */}
              <div>
                <h4 className="font-bold text-stone-900 text-sm mb-2">Hakkında</h4>
                <p className="text-stone-500 text-sm leading-relaxed">{selectedTrip.description}</p>
              </div>

              {/* Highlights */}
              <div>
                <h4 className="font-bold text-stone-900 text-sm mb-3">Öne Çıkanlar</h4>
                <ul className="space-y-2">
                  {selectedTrip.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-2.5">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-checkbox-circle-fill text-amber-500 text-base"></i>
                      </div>
                      <span className="text-stone-600 text-sm">{h}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Activities */}
              <div>
                <h4 className="font-bold text-stone-900 text-sm mb-3">Aktiviteler</h4>
                <div className="flex flex-wrap gap-2">
                  {selectedTrip.activities.map((act) => (
                    <span key={act} className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-stone-100 text-stone-700 font-medium">
                      <i className="ri-checkbox-blank-circle-fill text-amber-400 text-xs"></i>
                      {act}
                    </span>
                  ))}
                </div>
              </div>

              {/* Tips */}
              <div className="bg-stone-50 rounded-xl p-4 border border-stone-100">
                <h4 className="font-bold text-stone-900 text-sm mb-3 flex items-center gap-2">
                  <i className="ri-lightbulb-line text-amber-500"></i>
                  Pratik İpuçları
                </h4>
                <ul className="space-y-2">
                  {selectedTrip.tips.map((tip) => (
                    <li key={tip} className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-500 text-sm flex-shrink-0 mt-0.5"></i>
                      <span className="text-stone-500 text-xs leading-relaxed">{tip}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA */}
              <div className="flex gap-3 pt-2">
                <Link
                  to="/accommodations"
                  className="flex-1 flex items-center justify-center gap-2 py-3 bg-amber-500 hover:bg-amber-600 text-white text-sm font-bold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-hotel-line"></i>
                  Konaklama Bul
                </Link>
                <button
                  onClick={() => setSelectedTrip(null)}
                  className="px-5 py-3 border border-stone-200 text-stone-600 text-sm font-semibold rounded-xl hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default DayTripsGuide;
